module.exports = __webpack_public_path__ + "static/img/y_zhxt51.41ab3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_zhxt51.png
// module id = 7jAs
// module chunks = 73